import { Text, HStack, IconButton } from '@vimeo/bokeh';
import { CloseX } from '@vimeo/bokeh-icons';

type ModuleHeaderProps = {
  onClose?: VoidFunction;
  text: string;
  secondaryText?: number;
};

// Header for modules - children prop can be used to pass custom button
export const ModuleHeader = ({
  onClose,
  text,
  secondaryText,
  children,
}: React.PropsWithChildren<ModuleHeaderProps>) => {
  return (
    <HStack align="center" spacing={75} p={300}>
      <Text variant="heading-md" as="h2" color="text-primary">
        {text}
      </Text>
      {secondaryText ? (
        <Text color="text-secondary" variant="heading-md" as="h2">
          {secondaryText}
        </Text>
      ) : null}
      <HStack ml="auto" spacing={50}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="Close"
            variant="tertiary"
            size="sm"
            icon={<CloseX />}
            onClick={onClose}
          />
        ) : null}
      </HStack>
    </HStack>
  );
};
